import { useUTLSettingsContext } from "@dexteel/mesf-core";
import { Box, Divider, Paper } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useTimerContext } from "../../../context/timer.provider";
import { useEAFDataEntryActions } from "../../../hooks/useEAFDataEntryActions";
import { UpsertElectrodeEvent } from "../../modals/electrode-event/UpsertElectrodeEvent";
import { AgGridFooterActions } from "../components/AgGridFooterActions";
import { useEAFDETablesStyles } from "../styles/useEAFDETablesStyles";
import { useTableData } from "./hooks/useProbesTableData";

export const TableElectrodeEvents = () => {
	const {
		state: { deProcess },
	} = useDataEntryContext();

	const { deleteElectrodeEvent } = useEAFDataEntryActions();

	const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
	const [showEditModal, setShowEditModal] = useState<boolean>(false);
	const [selectedElectrodeEvent, setSelectedElectrodeEvent] = useState<any>();

	const { pause, resume } = useTimerContext();
	const electrodeEvents = deProcess?.electrodeEvents;
	const rowCount = electrodeEvents ? electrodeEvents.length : 0;
	const classes = useEAFDETablesStyles({ rowCount });

	const editElectrodeEvent = (electrodeEventId: number) => {
		pause();
		const electrodeEvent = electrodeEvents?.find(
			(e) => e.ElectrodeEventId === electrodeEventId,
		);
		setSelectedElectrodeEvent(electrodeEvent);
		setShowEditModal(true);
	};
	const { columns } = useTableData({
		deleteElectrodeEvent,
		editElectrodeEvent,
	});

	return (
		<>
			<Paper elevation={0}>
				<Box className={` ${classes.electrodeEventsAgGridBox}`}>
					<AgGridReact
						rowSelection="single"
						suppressRowClickSelection={true}
						pagination={false}
						singleClickEdit={false}
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						rowData={electrodeEvents}
						columnDefs={columns}
						domLayout="normal"
					/>
					<Divider />
					<AgGridFooterActions
						hasMaxItems={false}
						showCreateModal={showCreateModal}
						setShowCreateModal={setShowCreateModal}
						table="electrode-events"
					/>
				</Box>
			</Paper>
			<UpsertElectrodeEvent
				show={showCreateModal || showEditModal}
				onHide={() => {
					resume();
					setShowCreateModal(false);
					setShowEditModal(false);
					setSelectedElectrodeEvent(null);
				}}
				date={deProcess?.process?.End ? deProcess.process.Start : new Date()}
				electrodeEvent={selectedElectrodeEvent}
			/>
		</>
	);
};
